import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { dungPhien } from './auth/PhienDangNhap';
import { KhungChinh } from './layout/KhungChinh';
import { MAN_HINH, coManHinh } from './spec/man-hinh';
import { KhungTaiMan, taiMan } from './lib/tai-man';

// Mỗi màn là một gói riêng, chỉ tải khi người dùng mở tới (BOSS: tối ưu tốc độ).
const ManDangNhap = taiMan(() => import('./screens/DangNhap'), 'ManDangNhap');
const ManDashboard = taiMan(() => import('./screens/Dashboard'), 'ManDashboard');
const ManRaLenh = taiMan(() => import('./screens/RaLenh'), 'ManRaLenh');
const ManGuardrail = taiMan(() => import('./screens/Guardrail'), 'ManGuardrail');
const ManHangChoDuyet = taiMan(() => import('./screens/HangChoDuyet'), 'ManHangChoDuyet');
const ManCrm = taiMan(() => import('./screens/du-lieu'), 'ManCrm');
const ManDataBoard = taiMan(() => import('./screens/du-lieu'), 'ManDataBoard');
const ManDoiSoatMisa = taiMan(() => import('./screens/du-lieu'), 'ManDoiSoatMisa');
const ManDongBoHoaDon = taiMan(() => import('./screens/du-lieu'), 'ManDongBoHoaDon');
const ManNhatKy = taiMan(() => import('./screens/du-lieu'), 'ManNhatKy');
const ManQuangCaoMeta = taiMan(() => import('./screens/QuangCaoMeta'), 'ManQuangCaoMeta');
const ManZaloOa = taiMan(() => import('./screens/ZaloOa'), 'ManZaloOa');
const ManAiTraLoiKhach = taiMan(() => import('./screens/AiTraLoiKhach'), 'ManAiTraLoiKhach');
const ManTepKhachHang = taiMan(() => import('./screens/TepKhachHang'), 'ManTepKhachHang');
const ManYouTube = taiMan(() => import('./screens/YouTube'), 'ManYouTube');
const ManRobotMisa = taiMan(() => import('./screens/RobotMisa'), 'ManRobotMisa');
const ManAiTuVan = taiMan(() => import('./screens/AiTuVan'), 'ManAiTuVan');
const ManExtensionAlads = taiMan(() => import('./screens/ExtensionAlads'), 'ManExtensionAlads');
const ManCaiDat = taiMan(() => import('./screens/quan-tri'), 'ManCaiDat');
const ManCapQuyen = taiMan(() => import('./screens/quan-tri'), 'ManCapQuyen');
const ManHoSo = taiMan(() => import('./screens/quan-tri'), 'ManHoSo');
const ManKetNoi = taiMan(() => import('./screens/ket-noi'), 'ManKetNoi');
const ManKetNoiMcp = taiMan(() => import('./screens/KetNoiMcp'), 'ManKetNoiMcp');

/** Toàn bộ 15 màn hình — không còn màn nào là chỗ giữ sẵn. */
const MAN: Record<string, React.ComponentType> = {
  dashboard: ManDashboard,
  launcher: ManRaLenh,
  advisor: ManAiTuVan,
  extension: ManExtensionAlads,
  data: ManDataBoard,
  crm: ManCrm,
  connect: ManKetNoi,
  // BOSS 30/09/2026: đọc thẳng tài khoản quảng cáo Meta thật; sổ VIA nhập tay
  // cũ là một thẻ bên trong (?muc=so-via).
  accounts: ManQuangCaoMeta,
  // BOSS 01/10/2026: hộp thư + người dùng Zalo Official Account.
  zalo: ManZaloOa,
  // BOSS 16/10/2026: AI trả lời khách trên hộp chat Pancake + tự lên đơn.
  chatbot: ManAiTraLoiKhach,
  // BOSS 19/10/2026: CRM & CSKH › Tệp khách hàng.
  tep_khach: ManTepKhachHang,
  // BOSS 07/10/2026: số liệu từng kênh YouTube (chỉ đọc).
  youtube: ManYouTube,
  'robot-misa': ManRobotMisa,
  // `misa` là mục "Đối soát MISA" trên menu — chỗ kế toán thực sự bấm vào, nên
  // nó phải là màn ĐỐI SOÁT ĐẦY ĐỦ (5 thẻ, tích chọn, nguồn, đẩy đơn). Trước
  // 23/09/2026 mục này trỏ vào màn cũ chỉ liệt kê hoá đơn bên MISA, còn bản làm
  // mới lại nằm ở đường dẫn ẩn ngoài menu — kế toán không có cách nào bấm tới.
  misa: ManDongBoHoaDon,
  // Màn cũ giữ lại làm bản tra cứu hoá đơn GỐC bên MISA, ngoài menu.
  invsync: ManDoiSoatMisa,
  guardrail: ManGuardrail,
  queue: ManHangChoDuyet,
  log: ManNhatKy,
  settings: ManCaiDat,
  profile: ManHoSo,
  perms: ManCapQuyen,
};

/**
 * Chặn màn hình theo quyền `nav`. Đây CHỈ là lớp trình bày — backend vẫn tự
 * kiểm tra ở từng endpoint, nên sửa trong trình duyệt không mở thêm được gì.
 *
 * Hai màn ngoài menu không có công tắc `nav` riêng, đúng như thiết kế gốc:
 * `profile` ai đăng nhập được cũng vào được, `perms` mở theo `adm.perms`.
 * Giữ khớp với `MAN_NGOAI_MENU` ở `backend/src/middleware/auth.ts`.
 */
function CanQuyenMan({ id, children }: { id: string; children: JSX.Element }) {
  const { co, nguoiDung } = dungPhien();

  if (id === 'profile') return children;

  const duoc = id === 'perms' ? co('adm', 'perms') : id === 'robot-misa' ? co('nav', 'misa') : coManHinh(id, co, nguoiDung?.roleId);
  if (!duoc) {
    return (
      <div className="ag-the" style={{ maxWidth: 560 }}>
        <h2 style={{ fontSize: 16 }}>Không có quyền vào màn hình này</h2>
        <p className="ag-mo" style={{ marginTop: 6 }}>
          Tài khoản của bạn chưa được cấp quyền xem “
          {MAN_HINH.find((m) => m.id === id)?.label ?? id}”. Liên hệ Chủ doanh nghiệp
          nếu bạn cần quyền này.
        </p>
      </div>
    );
  }
  return children;
}

export function App() {
  const { dangTai, daDangNhap } = dungPhien();
  const viTri = useLocation();

  if (dangTai) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <p className="ag-mo">Đang tải phiên đăng nhập…</p>
      </div>
    );
  }

  if (!daDangNhap) {
    return (
      <Routes>
        <Route
          path="/dang-nhap"
          element={
            <KhungTaiMan>
              <ManDangNhap />
            </KhungTaiMan>
          }
        />
        {/* Giữ nguyên địa chỉ (cả ?yc=) — đăng nhập xong App vẽ lại đúng trang Cho phép kết nối Claude. */}
        <Route
          path="/ket-noi-mcp"
          element={
            <KhungTaiMan>
              <ManDangNhap />
            </KhungTaiMan>
          }
        />
        <Route
          path="*"
          element={<Navigate to="/dang-nhap" replace state={{ tu: viTri.pathname }} />}
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/dang-nhap" element={<Navigate to="/" replace />} />
      <Route
        path="/ket-noi-mcp"
        element={
          <KhungTaiMan>
            <ManKetNoiMcp />
          </KhungTaiMan>
        }
      />
      <Route element={<KhungChinh />}>
        {MAN_HINH.map((m) => {
          const Man = MAN[m.id];
          if (!Man) return null;
          return (
            <Route
              key={m.id}
              path={m.duong}
              element={
                <CanQuyenMan id={m.id}>
                  <KhungTaiMan>
                    <Man />
                  </KhungTaiMan>
                </CanQuyenMan>
              }
            />
          );
        })}
        <Route
          path="*"
          element={
            <div className="ag-the" style={{ maxWidth: 480 }}>
              <h2 style={{ fontSize: 16 }}>Không có trang này</h2>
              <p className="ag-mo" style={{ marginTop: 6 }}>
                Đường dẫn <code>{viTri.pathname}</code> không thuộc 15 màn hình của ALADS.
              </p>
            </div>
          }
        />
      </Route>
    </Routes>
  );
}
